import { Component } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-scan',
  templateUrl: './consignment-scan.component.html',
  styleUrls: ['./consignment-scan.component.css']
})
export class ConsignmentScanComponent {
    public barcode: string = '';

    public barcodeButtons: FormButton[] = [
        { id: 'calculator', icon: 'fa fa-calculator', type: 'primary', onClick: () => this.openCalculator('barcode') },
        { id: 'search', icon: 'fas fa-search', type: 'success', onClick: () => this.scanValue() }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {

    }

    private async scanValue() {
        if (!this.barcode) return;

        const response = (await this.datatask.Post(321, { barcode: this.barcode }))[0];

        if (response) {
            this.clear('barcode');
            this.stateService.go(response?.webpagename, response?.parms);
        } else {
            this.clear('barcode');
        }

        this.clear('barcode');
    }

    public submitSearch() {
        this.scanValue();
    }

    private async openCalculator(id: string) {
        switch (id) {
            case 'barcode':
                if (id === 'barcode') {
                    const value = await this.modal.showCalculator(this.barcode);

                    this.barcode = value;

                    this.scanValue();
                }
                break;
            default:
                break;
        };
    }

    private clear(id: string) {
        switch (id) {
            case 'barcode':
                if (this.barcode > '') {
                    this.barcode = '';
                }
                break;
            default:
                break;
        }
    }
}
